<template>
    <div class="course">
        <ul class="flex-align-between course-ul">
            <li v-for="(item, index) in list" :key="index" :class="calcStyle" @click="toCourseDetail">
                <img src="" alt="" :style="size">
                <div class="flex-column-between info">
                    <h3 class="wes-2">{{item.name}}</h3>
                    <div class="flex-align-between other-msg">
                        <span class="time flex-align">{{item.time}}</span>
                        <span>在学{{item.people}}人</span>
                    </div>
                </div>
            </li>
        </ul>
        <!-- TODO:加载更多 -->
    </div>
</template>

<script>
export default {
    props: {
        cloumn: {
            type:Number
        },
        height:{
            type:Number
        },
        width:{
            type:Number
        },
        load:{
            type:Boolean
        }
    },
    data(){
        return {
            size:{
                width: this.width? this.width + 'px' : 'auto',
                height: this.height? this.height + 'px' : '190px'
            },
            list:[{
                name:'趣味数学',
                time:'2020.06.21 19:00 - 21:00',
                people:65,
            },{
                name:'小学英语 吕帅：探索读写结合的教学路径与策略策策策策策策的教学路径与的教学路径与的教学路径与',
                time:'2020.06.21 19:00 - 21:00',
                people:65,
            },{
                name:'小学英语 吕帅：探索读写结合的教学路径与策略',
                time:'2020.06.21 19:00 - 21:00',
                people:65,
            },{
                name:'小学英语 吕帅：探索读写结合的教学路径与策略',
                time:'2020.06.21 19:00 - 21:00',
                people:65,
            }]
        }
    },
    computed:{
        calcStyle:function() {
            let lof = 'u-lof'
            this.cloumn ? lof = 'u-lof' + String(this.cloumn) : lof = lof +'2'
            return lof;
        }
    },
    methods:{
        toCourseDetail(){
            let id = 123;
            this.$router.push(`/news/course/detail/${id}`)
        }
    }
}
</script>

<style lang="less" scoped>
    .course-ul {
        flex-flow: row wrap;
        align-content: flex-start;

        .u-lof4 {
            flex: 0 0 24%;
        }

        .u-lof3 {
            flex: 0 0 33%;
        }

        .u-lof2 {
            flex: 0 0 49%;
        }
        li {
        margin-bottom: 20px;
        box-sizing: border-box;
        padding: 20px;

        background-color: #f2f2f2;
        cursor: pointer;
        }

        h3 {
            font-size: 16px;
        }

        img {
            display: block;

            margin-bottom: 10px;
            // height: 190px;

            background-color: #1c4b90;
        }

        .info {
            min-height: 82px;
        }

        .other-msg {
            font-size: 12px;

            color: #999;
        }

        .time::before {
            content: ' ';

            margin-right: 4px;
            width: 20px;
            height: 20px;

            background-image: url("../../../../static/news/time@2x.png");
            background-repeat: no-repeat;
        }
    }
</style>